import React from 'react'
import { OrderTicketStatus } from 'orders/schema'
import { Text } from 'uiComponents/typography'

interface OrderItemStatusProps {
    value: OrderTicketStatus
}

const OrderItemStatus: React.FC<OrderItemStatusProps> = ({ value }) => {
    return (
        <Text transform="capitalize" status={value === 'redeemed' ? 'success' : 'processing'}>
            {value}
        </Text>
    )
}

export default OrderItemStatus
